import Footer from "components/Footer";
import Navbar from "components/Navbar";
import { observer } from "mobx-react-lite";
import React from "react";
import { QueryClient, QueryClientProvider } from "react-query";

const Mainlayout = (props) => {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <div>
        {/* <div className="body-bg"> */}
        <Navbar />
        <div>{props.children}</div>
        {/* <MainContainer>{props.children}</MainContainer> */}
        <Footer />
      </div>
    </QueryClientProvider>
  );
};

export default observer(Mainlayout);
